import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import {
  UserNavigationApiClient,
  UserNavigationItem,
} from '@src/api/company/menu/userNavigationApiClient';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useCompanyAuth } from './auth/useCompanyAuth';

interface UserNavigationContextType {
  menuLinks: { title: string; link: string }[];
}

const UserNavigationContext = createContext<UserNavigationContextType | undefined>(undefined);

export const UserNavigationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [menuLinks, setMenuLinks] = useState<{ title: string; link: string }[]>([]);
  const { profile } = useCompanyAuth();
  const location = useLocation();

  useEffect(() => {
    const fetchManagementMenu = async () => {
      if (profile?.isLogin) {
        const res = await UserNavigationApiClient.get();
        handleApiResponse(res, (data) => {
          const items = data.map((item: UserNavigationItem) => ({
            title: item.title,
            link: item.link,
          }));
          setMenuLinks(items);
        });
      }
    };

    fetchManagementMenu();
  }, [location, profile?.isLogin]);

  return (
    <UserNavigationContext.Provider value={{ menuLinks }}>
      {children}
    </UserNavigationContext.Provider>
  );
};

export const useUserNavigation = () => {
  const context = useContext(UserNavigationContext);
  if (!context) {
    throw new Error('useUserNavigation must be used within UserNavigationProvider');
  }
  return context;
};
